import { useStaggerAnimation } from "@/hooks/useScrollAnimation";

const features = [
  {
    icon: "ri-award-line",
    title: "台灣設計師經典品牌",
    desc: "精選本土設計師匠心之作，每一件都融入對女性美學的深刻理解，展現無可取代的東方優雅氣質。",
  },
  {
    icon: "ri-history-line",
    title: "30 年口碑熱銷",
    desc: "三十年來深受無數女性信賴，品牌背後是對品質的堅持與對顧客的承諾，口碑自然傳遞。",
  },
  {
    icon: "ri-price-tag-3-line",
    title: "Outlet 精選優惠價格",
    desc: "Outlet 不等於廉價，而是以更親切的價格讓您入手真正值得珍藏的設計師品牌服飾。",
  },
  {
    icon: "ri-scissors-cut-line",
    title: "修飾版型·實穿好搭",
    desc: "每款設計都經過精心剪裁，版型修飾身型曲線，面料舒適高質感，真正兼顧形象與舒適。",
  },
];

export default function BrandFeatures() {
  const titleAnim = useStaggerAnimation(2);
  const cardsAnim = useStaggerAnimation(features.length);

  return (
    <section className="bg-[#faf8f5] py-20 md:py-28 overflow-hidden">
      <div className="w-full px-6 md:px-16 max-w-[1400px] mx-auto">
        {/* Title */}
        <div
          ref={titleAnim.ref as React.RefObject<HTMLDivElement>}
          className="text-center mb-14"
        >
          <p className={`text-[#8B5E52] text-[1rem] tracking-[0.25em] uppercase font-medium mb-3 transition-all duration-700 ${titleAnim.visibleItems[0] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            Why Choose Us
          </p>
          <h2 className={`text-[#3d2b1f] text-[2.125rem] md:text-[2.5rem] font-bold leading-[1.4] transition-all duration-700 delay-100 ${titleAnim.visibleItems[1] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            為何選擇我們
          </h2>
          <p className={`text-[#7a6455] text-[1.1875rem] mt-4 max-w-xl mx-auto leading-[1.75] transition-all duration-700 delay-200 ${titleAnim.visibleItems[1] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            三十年來，我們堅持為重視穿著品味的女性，提供最值得入手的設計師品牌服飾。
          </p>
        </div>

        {/* Cards */}
        <div
          ref={cardsAnim.ref as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8"
        >
          {features.map((f, i) => (
            <div
              key={i}
              className={`bg-white rounded-lg p-8 flex flex-col items-start gap-4 hover:shadow-[0_4px_24px_rgba(61,43,31,0.08)] transition-all duration-700 group ${cardsAnim.visibleItems[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-[#f5e8d8] group-hover:bg-[#8B5E52]/15 transition-colors duration-300">
                <i className={`${f.icon} text-[#8B5E52] text-2xl`}></i>
              </div>
              <h3 className="text-[#3d2b1f] text-[1.25rem] font-bold leading-[1.45]">{f.title}</h3>
              <p className="text-[#7a6455] text-[1.0625rem] leading-[1.75]">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
